/**
 * The identifier used to manage the language code in device storage.
 */
export const LanguageCodeStorageKey = 'BB_LANGUAGE_CODE';
/**
 * The languages supported by the internationalization library.
 */
export const SupportedLanguages = {
    /**
     * German - Germany
     */
    deDE: 'de-DE',
    /**
     * English - Australia
     */
    enAU: 'en-AU',
    /**
     * English - Great Britain
     */
    enGB: 'en-GB',
    /**
     * English - United States
     */
    enUS: 'en-US',
    /**
     * Spanish - Spain
     */
    esES: 'es-ES',
    /**
     * French - France
     */
    frFR: 'fr-FR',
    /**
     * Finnish - Finland
     */
    fiFI: 'fi-FI',
    /**
     * Japanese - Japan
     */
    jaJP: 'ja-JP',
    /**
     * Swedish - Sweden
     */
    svSE: 'sv-SE',
};
//# sourceMappingURL=constants.js.map